<template>
    <div>
        <h2 class="page-header">Thank You for Requesting a Quote</h2>

        <p v-if="this.$store.state.rtTicket">Ticket {{$store.state.rtTicket}} has been generated.</p>
        <p>A quote will be generated shortly and sent to the email address you have supplied. If you have not received a quote within 24 hours please contact us.</p>
        <p>Alternatively if you would like to speak to a Communications Consultant sooner, please call us on <a href="tel:0800060100" title="Switch Telecom Toll Free Telephone Number" target="_blank" class="text-dark font-weight-bold">0800 060 100</a> or email <a href="mailto:chat@switchtel.co.za" class="text-dark font-weight-bold">chat@switchtel.co.za</a>.</p>
    </div>
</template>

<script>

import store from  "@/store/index"; //vuex store

export default {
    name: "ThankYouQuote",
  
    mounted() {
 
    },
    data() {
        return {}
           
    }, //end of data

    methods: {
        
    }
};
</script>
